export const WHATSAPP_NUMBER = "447823718667";
export const WHATSAPP_DEFAULT_MSG = "Hi MPS! I'd like to place an order. My details: ";

export function buildWhatsAppLink(message = WHATSAPP_DEFAULT_MSG) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
